import React, { Component } from 'react'
import PropertyVisitContainer from '../../containers/property_visit_container';
import { Button,Segment, Header,Confirm } from 'semantic-ui-react'
import PropertyVisitReportTitlePage from './property_visit_report_title_page';
import Loader from '../universal/loader';
import PropertyVisitReportChecklist from './property_visit_report_checklist';
import PropertyVisitReportAlarms from './property_visit_report_alarms';
import LoginModal from '../universal/login_modal';
import PropertyVisitReportRooms from './property_visit_report_rooms_list';
import { PROPERTY_VISIT_API_URL } from '../../constants/api_routes';
import { changePVStatus } from '../../data/property_visit_api';
import { BASE_URL } from '../../constants/app_routes';
import { handleFileDownload } from "../../utils/download_file";
import DownloadingIntent from '../universal/toast';
import {refreshUserToken} from "../../utils/validate_session_expiry"
import PVChecklist  from './pv_completion_checklist';
import AdditionalPhotos from "../report/additional_photos"
import {downloadFile} from "../../data/dashboard_api";
 class PropertyVisitReportBuilder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportId: this.props.match.params.visitId,
      rooms: [],
      showPasswordWindow:false
    }
  }
  
   componentWillMount() {
    this.props.getPVReportById(this.state.reportId)
    
   }
   showEnterPasswordWindow = (show) => {
    this.setState({showPasswordWindow:show});
};  
    
  validateLogin = (email,password,otp_attempt) => {
      this.setState({loggingin:true});
      refreshUserToken(email,password,otp_attempt).then((res)=>{
          this.setState({loggingin:false});
          if(res.success){
              this.showEnterPasswordWindow(false);
          }
          else {
              this.setState({loginError:res.error,loggingin:false});
          }
      });
    };
   handleDownload = async () => {
     this.setState({ isDownloading: true, showDownload: true });
     const URL = BASE_URL + "/pv/download/" + this.state.reportId;
     const fileName = this.props.data['filename'];
     await handleFileDownload(URL, fileName);
     this.setState({ isDownloading: false });
   };
   submitReport = () => {
     this.setState({ submittingReport: true });
     if (this.state.submitStatus) {
       const formData = {
         pv_id: this.props.data['id'],
         status: this.state.submitStatus
       };
       const URL = BASE_URL + "/pv/download/" + this.state.reportId;
       downloadFile(URL).then((r) => {
       changePVStatus(PROPERTY_VISIT_API_URL, formData).then((response) => {
         if (response.success) {
           this.props.history.push('/property_visit');
         }
         this.setState({ submittingReport: true });
        })
       })
     }
   };
   
   handleCancel = () => {
    this.setState({showConfirm:false})
     
   }

  render() {
    return (

      <div className="pad-bottom">
        {this.props.data &&
            <div className="pad-all header-sticky report-container">
                <Button primary className="pull-right" content="Download Report" onClick={this.handleDownload}/>
                {this.props.userRole === "clerk" &&
                <Button positive className="pull-right" content="Submit Report" onClick={() => {this.setState({showChecklist:true}) }} />}
                {this.props.userRole === "admin" &&
                 <Button primary className="pull-right" content="Checklist" onClick={() => {
                     this.setState({showChecklist:true})
                }} />}
                {this.props.userRole === "admin" &&
                <Button positive className="pull-right" content="Complete Report" onClick={() => {
                    this.setState({showConfirm:true,submitStatus:"completed"})
                }} />}
                <Header as='h3'
                        content={this.props.data['address'] ? "Address : " + this.props.data['address'].replace(/,+/g, ",") : ""}
                        textAlign='left'
                        style={{marginTop: '0'}}
                />
            </div>}
            {this.state.submittingReport && <Loader />}
        {this.props.isFetching && <Loader />}
        {this.state.showConfirm && <div><Confirm open={true} header="Confirm report submission" content="Report once submitted cannot be edited again" onCancel={this.handleCancel} onConfirm={this.submitReport} /></div>}
        {this.state.showChecklist && <PVChecklist userRole={this.props.userRole}completeReport ={() => {this.setState({showConfirm:true, showChecklist:false,submitStatus:"submitted"})}}handleClose={()=>{this.setState({showChecklist:false})}}showChecklist={this.state.showChecklist} reportId={this.state.reportId} /> }
        {this.props.data && !this.props.isFetching && 
            
          <Segment style={{ width: '75%', margin: 'auto' }}>
          <Segment>
            <PropertyVisitReportTitlePage reportId={this.props.data.id} titleImage={this.props.data.title_image} />
          </Segment>
          <PropertyVisitReportChecklist showPasswordWindow={this.showEnterPasswordWindow} reportId={this.props.data.id} reportData={this.props.data}  />
            <PropertyVisitReportAlarms showPasswordWindow={this.showEnterPasswordWindow} reportId={this.props.data.id} reportData={this.props.data} />
            <PropertyVisitReportRooms reloadData={()=> this.props.getPVReportById(this.state.reportId)}showPasswordWindow={this.showEnterPasswordWindow}reportId={this.props.data.id} reportData={this.props.data}></PropertyVisitReportRooms>
            {this.state.showPasswordWindow && <LoginModal reLogin={(email, password,otp_attempt) => {this.validateLogin(email,password,otp_attempt)}} messages={this.state.loginError} reloggingin={this.state.loggingin}/>}
          <Segment><AdditionalPhotos pv_id={this.props.data.id}/></Segment>
        </Segment>
        }
        {this.state.showDownload && <DownloadingIntent isDownloading={this.state.isDownloading} />}
      </div>

    )
  }
 }

export default PropertyVisitContainer(PropertyVisitReportBuilder);



// WEBPACK FOOTER //
// ./src/views/property_visits/property_visit_report_builder.js